module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.26847",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6927",
      "conversations-error-reporting": "static-1.8201",
      "conversations-internal-pub-sub": "static-1.15286",
      "conversations-internal-schema": "static-1.11926",
      "conversations-message-history": "static-1.10435",
      "conversations-test-sdk": "static-1.9741",
      "conversations-visitor-experience-components": "static-1.20210",
      "head-dlb": "static-1.4360",
      "hs-promise-utils": "static-1.4806",
      "hs-test-utils": "static-1.7292",
      "hubspot-dlb": "static-2.1702",
      "HubStyleTokens": "static-2.10798",
      "I18n": "static-7.1443",
      "jasmine-immutable": "static-1.2248",
      "jasmine-runner": "static-1.5706",
      "quartz": "static-1.6080",
      "react-dlb": "static-1.60",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.75",
      "urlinator": "static-1.3821",
      "viral-links-lib": "static-1.6185",
      "visitor-ui-component-library": "static-1.5458",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3849",
      "atom": "static-1.4433",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4073",
      "conversations-infrastructure": "static-1.8222",
      "conversations-prop-types": "static-1.6730",
      "conversations-visibility-tools": "static-1.5053",
      "conversations-visitor-message-history": "static-1.18947",
      "cssUtils": "static-1.589",
      "enviro": "static-4.328",
      "flux-actions": "static-1.285",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.5499",
      "hubspot-url-utils": "static-1.3516",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.9032",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "react": "static-7.151",
      "react-aria": "static-1.44",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1-jg-correct-duration-metric.4",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4695",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3659",
      "sanitize-text": "static-1.7434",
      "signup-constants": "static-1.17378",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.474",
      "usage-tracker": "static-1.6729",
      "usage-tracker-core": "static-1.6579",
      "usage-tracker-multi": "static-1.5143",
      "usage-tracker-public": "static-1.6540",
      "visitor-ui-component-library-icons": "static-1.5269",
      "hs-promise-rejection-tracking": "static-1.4750",
      "raven-hubspot": "static-1.5536",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2841",
      "moment": "static-3.26",
      "quartz-core": "static-1.5299",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.4160",
      "foundations-components": "static-1.6768",
      "foundations-theming": "static-1.3618",
      "UIComponents": "static-3.7745",
      "cv-backend-services": "static-1.1313",
      "immutable-less": "static-1.3840",
      "conversations-skeleton-state": "static-1.6645",
      "icons": "static-2.593",
      "react-input-autosize": "static-2.17",
      "react-virtualized": "static-2.80",
      "rpc-client-utils": "static-1.3994",
      "ui-images": "static-2.954",
      "permission-components": "static-1.4643",
      "HeadJS": "static-2.618",
      "framer-motion": "static-1.51",
      "hs-test-utils-bend-plugin": "static-1.2403",
      "msw": "static-1.39",
      "testing-library": "static-1.133",
      "i18n-data": "static-1.206",
      "moment-timezone": "static-5.66",
      "jasmine": "static-4.3612",
      "quartz-core-utils": "static-1.2947",
      "signup-ui-url-generator": "static-2.7358",
      "HubStyle": "static-2.11106",
      "sassPrefix": "static-1.139",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.5146",
      "dispatcher": "static-1.120",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.690",
      "hub-http-shared-msw-handlers": "static-1.8196",
      "hubspotter-http": "static-1.3958",
      "hubspotter-http-shared-msw-handlers": "static-1.8194",
      "mobile-manifest-mixins": "static-1.389",
      "platform-navigation-bootstrap": "static-1.11751",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.333",
      "hs-story-utils": "static-1.8647",
      "bend-plugin-foundations-components": "static-1.3037",
      "floating-ui": "static-1.39",
      "foundations-theming-specialty": "static-1.1334",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.2101",
      "foundations-theming-base": "static-1.2603",
      "ts-schema": "static-1.3484",
      "platform-infra-nav-components": "static-1.7067"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.26847",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6927",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8201",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15286",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11926",
      "conversations-message-history": "/conversations-message-history/static-1.10435",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9741",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.20210",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-promise-utils": "/hs-promise-utils/static-1.4806",
      "hs-test-utils": "/hs-test-utils/static-1.7292",
      "hubspot-dlb": "/hubspot-dlb/static-2.1702",
      "HubStyleTokens": "/HubStyleTokens/static-2.10798",
      "I18n": "/I18n/static-7.1443",
      "jasmine-immutable": "/jasmine-immutable/static-1.2248",
      "jasmine-runner": "/jasmine-runner/static-1.5706",
      "quartz": "/quartz/static-1.6080",
      "react-dlb": "/react-dlb/static-1.60",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.75",
      "urlinator": "/urlinator/static-1.3821",
      "viral-links-lib": "/viral-links-lib/static-1.6185",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5458",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3849",
      "atom": "/atom/static-1.4433",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4073",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8222",
      "conversations-prop-types": "/conversations-prop-types/static-1.6730",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.5053",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.18947",
      "cssUtils": "/cssUtils/static-1.589",
      "enviro": "/enviro/static-4.328",
      "flux-actions": "/flux-actions/static-1.285",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.5499",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3516",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.9032",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "react": "/react/static-7.151",
      "react-aria": "/react-aria/static-1.44",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1-jg-correct-duration-metric.4",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4695",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3659",
      "sanitize-text": "/sanitize-text/static-1.7434",
      "signup-constants": "/signup-constants/static-1.17378",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.474",
      "usage-tracker": "/usage-tracker/static-1.6729",
      "usage-tracker-core": "/usage-tracker-core/static-1.6579",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5143",
      "usage-tracker-public": "/usage-tracker-public/static-1.6540",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5269",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2841",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5299",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.4160",
      "foundations-components": "/foundations-components/static-1.6768",
      "foundations-theming": "/foundations-theming/static-1.3618",
      "UIComponents": "/UIComponents/static-3.7745",
      "cv-backend-services": "/cv-backend-services/static-1.1313",
      "immutable-less": "/immutable-less/static-1.3840",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6645",
      "icons": "/icons/static-2.593",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-virtualized": "/react-virtualized/static-2.80",
      "rpc-client-utils": "/rpc-client-utils/static-1.3994",
      "ui-images": "/ui-images/static-2.954",
      "permission-components": "/permission-components/static-1.4643",
      "HeadJS": "/HeadJS/static-2.618",
      "framer-motion": "/framer-motion/static-1.51",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2403",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.133",
      "i18n-data": "/i18n-data/static-1.206",
      "moment-timezone": "/moment-timezone/static-5.66",
      "jasmine": "/jasmine/static-4.3612",
      "quartz-core-utils": "/quartz-core-utils/static-1.2947",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7358",
      "HubStyle": "/HubStyle/static-2.11106",
      "sassPrefix": "/sassPrefix/static-1.139",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5146",
      "dispatcher": "/dispatcher/static-1.120",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.690",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8196",
      "hubspotter-http": "/hubspotter-http/static-1.3958",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8194",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.389",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11751",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.333",
      "hs-story-utils": "/hs-story-utils/static-1.8647",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3037",
      "floating-ui": "/floating-ui/static-1.39",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1334",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2101",
      "foundations-theming-base": "/foundations-theming-base/static-1.2603",
      "ts-schema": "/ts-schema/static-1.3484",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7067"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};